import { Menu, rem } from "@mantine/core";
import { t } from "i18next";

import { useQuoteRequestLine } from "#modules/quoteRequestLines/view/useQuoteRequestLine";
import { useValidateCosting } from "#modules/quoteRequestLines/views/useValidateCosting";
import { Icon, IconName } from "#shared/icons/Icon";
import { Tooltip } from "#shared/view/designSystem/Tooltip";
import { PartTypeSchema } from "shared";

export const ValidateMenuItem = ({ quoteRequestLineId }: { quoteRequestLineId: string }) => {
  const { quoteRequestLine } = useQuoteRequestLine({
    id: quoteRequestLineId,
  });

  const isConsumable = quoteRequestLine?.part.type === PartTypeSchema.enum.CONSUMABLE;

  const { validateCosting } = useValidateCosting(quoteRequestLine?.quoteRequestId);

  const { validateIcon, validateTooltipMessage, validateMenuItemText } = validationDisplayData(
    quoteRequestLine?.isReliable,
  );

  return (
    <Tooltip
      multiline
      w={250}
      label={validateTooltipMessage}
      transitionProps={{ transition: "fade", duration: 400 }}
    >
      <Menu.Item
        disabled={isConsumable}
        leftSection={<Icon name={validateIcon} style={{ width: rem(14), height: rem(14) }} />}
        onClick={() => validateCosting(quoteRequestLineId)}
      >
        {validateMenuItemText}
      </Menu.Item>
    </Tooltip>
  );
};

export const validationDisplayData = (isReliable: boolean | undefined) => {
  const validateIcon: IconName = isReliable ? "x" : "check";

  const validateTooltipMessage = isReliable
    ? t("quoteRequestLine.unvalidatedTooltip")
    : t("quoteRequestLine.validatedTooltip");

  const validateMenuItemText = isReliable
    ? t("quoteRequestLine.actions.unvalidate")
    : t("quoteRequestLine.actions.validate");

  const validateColor = isReliable ? "grey" : "blue";

  return {
    validateIcon: validateIcon as IconName,
    validateTooltipMessage,
    validateMenuItemText,
    validateColor,
  };
};
